import React from "react"

export const Subfooter = () => (
  <div className="bg-white text-neutral-500 px-2 md:px-16">
    <div className="container w-full text-xs leading-[24px] px-9 py-4 md:py-12">
      <p className="mb-4">
        Please download the Hadley app to receive your free 529 plan
        recommendation. The material contained on this website is not intended
        to be a recommendation or investment advice, does not constitute a
        solicitation to buy, sell or hold a security or investment strategy and
        is not provided in a fiduciary capacity. The information provided does
        not take into account the specific objectives or circumstances of any
        particular investor or suggest any specific course of action. Investment
        decisions should be made based on an investor’s objectives and
        circumstances and in consultation with her or her financial
        professionals. Past performance is no guarantee of future results. There
        can be no assurance that any investment will achieve its objectives or
        avoid substantial losses. 
      </p>
      <p className="mb-4">
        All research and other information provided on this website has been
        prepared for informational purposes only and Hadley Investment Co.
        assumes no liability or responsibility for any errors or omissions in
        the content of this website or any linked website.
      </p>
    </div>
  </div>
)
